export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const ERROR_OCCUR = 'ERROR_OCCUR';
export const ERROR_REMOVE = 'ERROR_REMOVE';
export const AUTH_EXPIRE = 'AUTH_EXPIRE';
